import { Component, OnDestroy, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subscription } from 'rxjs';
import { formatDate } from '@angular/common';
import { FormGroup, FormBuilder} from '@angular/forms';
import { NgbModalConfig, NgbModal, ModalDismissReasons, NgbCalendar, NgbDateAdapter } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { listProjectStage } from 'src/app/web/interfaces/project/stages/create/listProjectStage';
import { ApiServiceProject } from '../../../../../../apis/ApiServiceProject';
import { ErrorService } from 'src/app/shared/services/errors.service';
import * as moment from 'moment';

@Component({
  selector: 'step3-popup',
  templateUrl: './step3-popup.component.html',
  styleUrls: ['./step3-popup.component.scss']
})
export class Step3PopupComponent implements OnInit, OnDestroy {


  @ViewChild('defaultTabButtons')
  public defaultTabButtonsTpl: TemplateRef<any>;
  closeResult = ''
  model2: string
  listProjectStage: listProjectStage[] = [];
  popForm: FormGroup;
  type: string;
  edit: boolean;
  listUser
  listType
  id
  create: boolean;
  itemName: string;
  projectId: number;
  idSubcription: Subscription;
  stageid
  selectedDependence
  probabilityName = 0;
  listAssigned: []

  constructor(
    private spinner: NgxSpinnerService,
    private config: NgbModalConfig,
    private modalService: NgbModal,
    private apiService: ApiServiceProject,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private ngbCalendar: NgbCalendar,
    private dateAdapter: NgbDateAdapter<string>,
    private errorService:ErrorService

  ) {
    this.idSubcription = this.activatedRoute.params.subscribe(params => {
      return this.projectId = params['id'];
    })
   
  }

  ngOnDestroy(): void {
    this.idSubcription.unsubscribe();
  }
formSubmit(): void {
    this.spinner.show();
      
      let startDate = moment(this.popForm.value.start_date).format("DD-MM-YYYY"); 

      let endDate = moment(this.popForm.value.end_date).format("DD-MM-YYYY"); 

     let body = {
       id:Number(this.id),
       type_id:Number(this.popForm.value.type_id),
       start_date:startDate,
       end_date:endDate,
       assigned:Number( this.popForm.value.assigned),
    }

    this.apiService
        .putServiceBody(`update-project-datos-step-three`,body)
        .subscribe({
          next: (rs: any) => {
            if(rs.message){
              this.spinner.hide();
              Swal.fire({title:'Asignacion actualizada correctamente' + '' ,text: '',icon: 'success',heightAuto: false}).then(()=>{location.reload()});
            }
            else{
              this.spinner.hide();
              Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
            }
          },
          error: (error) => {
            this.errorService.error(error);
          },
        });
  }

  ngOnInit(): void {
   this.popForm = this.fb.group({
      type_id: [''],
      start_date: [''],
      end_date: [''],
      assigned: [''],
    });
    
  }

  public open(
    item:any,
    listType
  ) { 
    this.listType = listType;
    let rol
    this.listType.map((d)=>{
      if(d.name == item.name ){
        rol = d.id
      }
    })
    this.id = item.id
    if(item.start && item.end){
      this.popForm.patchValue({
      type_id: rol,
      start_date:   moment(item.start, 'DD-MM-YYYY').format("YYYY-MM-DD"),
      end_date:   moment(item.end, 'DD-MM-YYYY').format("YYYY-MM-DD"),
      assigned: item.allocation
    })
    }
    else{
      this.popForm.patchValue({
      type_id: rol,
      start_date: null  ,
      end_date:null ,
      assigned: item.allocation
    })
    }
    
     this.modalService.open(this.defaultTabButtonsTpl, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    })
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  

  validField(field, form) {
    return form.controls[field].errors
      && form.controls[field].touched;
  }

  clearForm() {
   
    this.type = ''
  }



}

